"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StepContentComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StepContent = _interopRequireDefault(require("@mui/material/StepContent"));
var _uiTheme = require("@kyruus/ui-theme");
const _overrides = theme => ({
  MuiStepContent: {
    styleOverrides: {
      root: {
        borderColor: theme.color_text_secondary
      }
    }
  }
});
const StepContentComponent = exports.StepContentComponent = (0, _uiTheme.withMuiThemeAdapter)(_StepContent.default, _overrides);
// This is silly, but it optimizes for developers.
// react-docgen can't find the propTypes unless it
// sees a component defininition.
const StepContent_ = props => /*#__PURE__*/_react.default.createElement(StepContentComponent, props);
StepContent_.displayName = 'StepContent';

// PropTypes taken from material-ui.
StepContent_.propTypes = process.env.NODE_ENV !== 'production' ? {
  /**
   * @ignore
   * Expands the content.
   */
  active: _propTypes.default.bool,
  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: _propTypes.default.bool,
  /**
   * Step content.
   */
  children: _propTypes.default.node,
  /**
   * @ignore
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * @ignore
   */
  completed: _propTypes.default.bool,
  /**
   * @ignore
   */
  last: _propTypes.default.bool,
  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional property.
   */
  optional: _propTypes.default.bool,
  /**
   * @ignore
   */
  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
  /**
   * Collapse component.
   */
  transition: _propTypes.default.func,
  /**
   * Adjust the duration of the content expand transition.
   * Passed as a property to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
    enter: _propTypes.default.number,
    exit: _propTypes.default.number
  }), _propTypes.default.oneOf(['auto'])])
} : {};
var _default = exports.default = StepContent_;
StepContent_.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "StepContent"
};